import React from "react";
import styled from "styled-components";
import useAuth from "../../hooks/useAuth";
import SearchableSelect from "../Common/SearchableSelect";

const FooterContainer = styled.footer`
  width: 100%;
  height: var(--footer-height);
  background-color: ${(props) => props.theme.footerBackground};
  color: ${(props) => props.theme.footerText};
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  position: fixed;
  bottom: 0;
  left: 0;
  box-sizing: border-box;
`;

const Version = styled.span`
  font-size: 0.75rem;
  opacity: 0.7;
`;

const SedeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.78rem;
`;

const SedeLabel = styled.span`
  color: ${(props) => props.theme.footerTextSede};
  white-space: nowrap;
`;

const SedeName = styled.span`
  font-size: 0.78rem;
  font-weight: 600;
  color: ${(props) => props.theme.footerTextSede};
`;

const Footer = () => {
  const { sedes = [], sedeActiva, selectSede } = useAuth();

  const handleSedeChange = (val) => {
    const sede = sedes.find((s) => String(s.id) === String(val));
    if (sede) selectSede(sede);
  };

  return (
    <FooterContainer>
      <Version>Versión 2025_1</Version>

      {/* MULTI-EMPRESA ACTIVADO */}
      {sedeActiva && (
        <SedeWrapper>
          <SedeLabel>Sede:</SedeLabel>
          {sedes.length > 1 ? (
            <SearchableSelect
              value={sedeActiva.id}
              onValueChange={handleSedeChange}
              options={sedes}
              getOptionValue={(s) => String(s.id)}
              getOptionLabel={(s) => s.nombreSede}
              placeholder="Seleccione sede..."
              multiple={false}
              searchable={true}
              sx={{
                minWidth: "160px",
                maxWidth: "260px",
                "& .MuiOutlinedInput-root": {
                  height: "22px",
                  minHeight: "22px",
                  borderRadius: "5px",
                  fontSize: "0.75rem",
                  fontFamily: "var(--font-body)",
                  bgcolor: "#ffffff",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#cbd5e1",
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#94a3b8",
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: "#2563eb",
                },
              }}
              selectSx={{
                height: "22px",
                minHeight: "22px",
                "& .MuiSelect-select": {
                  padding: "1px 24px 1px 8px !important",
                  fontSize: "0.75rem",
                  fontFamily: "var(--font-body)",
                  color: "#334155",
                  lineHeight: "20px",
                },
                "& .MuiSelect-icon": {
                  fontSize: "18px",
                  right: "4px",
                },
              }}
            />
          ) : (
            <SedeName>{sedeActiva.nombreSede}</SedeName>
          )}
        </SedeWrapper>
      )}
    </FooterContainer>
  );
};

export default Footer;
